var f = Object.defineProperty;
var L = (i, t, s) => t in i ? f(i, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : i[t] = s;
var a = (i, t, s) => (L(i, typeof t != "symbol" ? t + "" : t, s), s);
import "fabric";
import "@turf/turf";
import "./index.es175.js";
import "./index.es176.js";
import { calcCalloutScale as S, getDefaultOffset as h } from "./index.es252.js";
import { RoadLabel as c } from "./index.es497.js";
import { RoadLabelCalloutBox as T } from "./index.es172.js";
class G {
  constructor(t) {
    a(this, "_layerDataMap");
    a(this, "_map");
    a(this, "_mapId");
    a(this, "_subLayerId");
    a(this, "_layerGroupId");
    a(this, "_combinedLayerId");
    a(this, "_labelInfo");
    a(this, "_styleType");
    a(this, "_visible");
    a(this, "_drawType");
    a(this, "_roadLabelCalloutBoxConfig");
    a(this, "_offset");
    a(this, "_isSelected");
    a(this, "_generateRoadLabel", async () => {
      const t = new c({
        layerGroupId: this._layerGroupId,
        subLayerId: this._subLayerId,
        combinedLayerId: this._combinedLayerId,
        styleType: this._styleType,
        labelInfo: this._labelInfo
      });
      return await t.generate(), t;
    });
    a(this, "generate", async () => {
      var y;
      const t = this._map, { poiId: s } = this._labelInfo, o = this._layerDataMap.get(s), e = (y = o == null ? void 0 : o.renderedCalloutBox) == null ? void 0 : y.labelInfo.styleConfig, l = this._roadLabelCalloutBoxConfig;
      if (o && o.poiInfo.isSelected === this._labelInfo.isSelected && o.poiInfo.isLocked === this._labelInfo.isLocked && o.poiInfo.isEditing === this._labelInfo.isEditing && o.poiInfo.tempLabel === this._labelInfo.tempLabel && o.poiInfo.trafficVolumeMetric === this._labelInfo.trafficVolumeMetric && (e == null ? void 0 : e.additionalStyleFont) === l.additionalStyleFont && (e == null ? void 0 : e.additionalStyleFontColor) === l.additionalStyleFontColor && (e == null ? void 0 : e.additionalStyleFontColorOpacity) === l.additionalStyleFontColorOpacity && (e == null ? void 0 : e.additionalStyleFontWeight) === l.additionalStyleFontWeight && (e == null ? void 0 : e.additionalStyleSize) === l.additionalStyleSize && (e == null ? void 0 : e.bgCornerRadius) === l.bgCornerRadius && (e == null ? void 0 : e.bgEnabled) === l.bgEnabled && (e == null ? void 0 : e.bgFillColor) === l.bgFillColor && (e == null ? void 0 : e.bgFillColorOpacity) === l.bgFillColorOpacity && (e == null ? void 0 : e.bgStroke) === l.bgStroke && (e == null ? void 0 : e.roadLabelType) === l.roadLabelType && (e == null ? void 0 : e.showRoadLabelNames) === l.showRoadLabelNames)
        return {
          calloutBox: o,
          fromCache: !0
        };
      const { geolocation: n } = this._labelInfo, _ = t.project(n), p = t.getZoom(), r = await this._generateRoadLabel(), b = r.objType, I = r.getTenantsCalloutBoxObjs(), u = S(p, b), m = h(b), d = new T({
        children: [I],
        layerGroupId: this._layerGroupId,
        subLayerId: this._subLayerId,
        combinedLayerId: this._combinedLayerId,
        styleType: this._styleType,
        projectedXYSource: _,
        offsetXYFromSource: this._offset ? Object.assign({}, this._offset) : m,
        fabricObjScale: u,
        visible: this._visible,
        poiInfo: this._labelInfo,
        status: this._isSelected ? "select" : "idle",
        map: this._map
      });
      return d.renderedCalloutBox = r, this._layerDataMap.set(s, d), {
        calloutBox: d,
        fromCache: !1
      };
    });
    this._map = t.map, this._mapId = t.mapId, this._layerDataMap = t.layerDataMap, this._subLayerId = t.subLayerId, this._layerGroupId = t.layerGroupId, this._combinedLayerId = t.combinedLayerId, this._labelInfo = t.data, this._styleType = t.styleType, this._drawType = t.data.drawType, this._visible = t.data.visible, this._roadLabelCalloutBoxConfig = t.data.styleConfig, this._offset = t.data.offset, this._isSelected = t.data.isSelected;
  }
}
export {
  G as RoadlabelFactory
};
//# sourceMappingURL=index.es449.js.map
